import { Trans } from "@lingui/react/macro";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { AppModel } from "../../../app/app-model";
import { Button } from "../../../components/ui-kit/button";
import { EnrollDialog } from "./enroll-dialog";

export function ClinicalStudiesRoute(props: { app: AppModel }) {
  const [showEnrollDialog, setShowEnrollDialog] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      <p className="mt-4 mb-4">
        <Trans>
          Select an enrollment from the sidebar to view details, or enroll the
          patient in a new study.
        </Trans>
      </p>
      <Button onClick={() => setShowEnrollDialog(true)}>
        <Trans>Enroll in new study</Trans>
      </Button>
      {showEnrollDialog && (
        <EnrollDialog
          app={props.app}
          onClose={() => setShowEnrollDialog(false)}
          onSaved={(acronym) => {
            setShowEnrollDialog(false);
            void navigate(acronym);
          }}
        />
      )}
    </div>
  );
}
